import React, { useEffect, useState } from "react";
import mainImg from "../img/main-image.png";
import { Link } from "react-router-dom";
import { APP_NAME } from "../utils/constants";

const MainCard = () => {
	const [courseChar, setCourseChar] = useState("");
	const [courseIdx, setCourseIdx] = useState(0);
	const [courseChars, setCourseChars] = useState("");
	const [courseCharIdx, setCourseCharIdx] = useState(0);
	const course = [
		"Web Development",
		"Java",
		"Python",
		"DSA",
		"C Programming",
		"C++",
		"Data Science",
	];
	useEffect(() => {
		const intervalId = setInterval(() => {
			setCourseChar(() => {
				return course[courseIdx];
			});
			setCourseIdx(courseIdx + 1);

			setCourseCharIdx(0);
			if (courseIdx === course.length - 1) {
				setCourseIdx(0);
			}
		}, 3500);

		return () => {
			clearInterval(intervalId);
		};
	}, [courseIdx]);
	useEffect(() => {
		const intervalId2 = setInterval(() => {
			setCourseChars(() => {
				return courseChar.substring(0, courseCharIdx);
			});
			setCourseCharIdx(courseCharIdx + 1);
			if (courseChar.length < courseCharIdx) {
				setCourseCharIdx(courseChar.length);
			}
		}, 200);

		return () => {
			clearInterval(intervalId2);
		};
	}, [courseCharIdx]);
	return (
		<div className="px-4 pt-4">
			<div className="w-full lg:h-[50vh] rounded-md  relative overflow-hidden">
				<div className="w-full h-full flex">
					<div className="bg-white h-full w-full lg:w-[50%] p-4 flex flex-col gap-4 items-center lg:items-start justify-center">
						<h1 className="text-4xl font-bold text-center sm:text-start">
							Welcome to{" "}
							<span className="text-orange-600">{APP_NAME}</span>
						</h1>
						<h3 className="text-2xl font-semibold  w-fit transition-all">
							Learn{" "}
							<span className="text-orange-600 font-bold">
								{courseChars}
							</span>
							<span className="animate-ping">|</span>
						</h3>
						<p className="font-normal opacity-85 line-clamp-6">
							Confused on which course to take? I have got you
							covered. Browse courses and find out the best course
							for you. Its free! Code With Harry is my attempt to
							teach basics and those coding techniques to people
							in short time which took me ages to learn.
						</p>
						<div>
							<Link to="/courses">
								<button className="px-4 py-2 rounded-md bg-black text-white mr-1">
									Free Courses
								</button>
							</Link>
							<Link to="/blog">
								<button className="px-4 py-2 rounded-md bg-gray-400 text-black m-1">
									Explore Blog
								</button>
							</Link>
						</div>
					</div>
					<div
						className="bg-blue-500/40 h-full w-[50%] translate-x-10 hidden lg:inline-block relative"
						style={{
							clipPath:
								"polygon(15% 0px, 100% 0%, 100% 100%, 0% 100%)",
						}}
					>
						<img
							className="w-full h-full object-cover object-center"
							src={mainImg}
							alt="Main-Img"
						></img>
						<div className="w-full h-full flex items-center justify-center z-40 absolute top-0">
							<span className="text-white  font-bold text-2xl whitespace-nowrap mr-3 translate-x-1/4 scale-105 animate-pulse">
								&lt; {APP_NAME} /&gt;
							</span>
						</div>
						<div className="w-[50%] h-[100%] bg-gray-400 opacity-50 rounded-s-full rotate-45 absolute -bottom-32 -right-32"></div>
						<div className="w-[28%] h-[60%] bg-gray-400 opacity-50 rounded-full rotate-45 absolute -top-4 -right-32"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MainCard;
